import {ftime, date} from '@eitje/utils'
import {t} from '@eitje/bridge'
import {DateRangeActiveRecord} from './base'

export const contractJoins = {joins: ['userEmploymentTypes', 'salaries', 'contractHolders', 'workSchedules']}

class ContractPart extends DateRangeActiveRecord {
	formatDateRange() {
		return `${ftime(this.start_date, 'dayMonthYear')} - ${this.formattedEndDate()}`
	}

	startDate() {
		return date(this.start_date)
	}

	formattedEndDate() {
		return this.end_date ? ftime(this.end_date, 'dayMonthYear') : t(['common.indefinite', 'indefinite']) // kept second trans key for web backwards compatability
	}

	endDate() {
		return this.end_date && date(this.end_date)
	}
}

export default ContractPart
